import UK01_1B2P_V1 from './uk_01/Scarlet-100-1B2Pv1.json.js';
import UK01_1B2P_V2 from './uk_01/Scarlet-101-1B2Pv2.json.js';
import UK01_2B3P_V1 from './uk_01/Scarlet-200-2B3Pv1.json.js';
import UK01_2B3P_V2 from './uk_01/Scarlet-202-2B3Pv2.json.js';
import UK01_2B4P_V1 from './uk_01/Scarlet-201-2B4Pv1.json.js';
import UK01_3B5P_V1 from './uk_01/Scarlet-300-3B5Pv1.json.js';
import UK01_3B6P_V1 from './uk_01/Scarlet-301-3B6Pv1.json.js';
import UK02_1B1P_01 from './uk_02/UNT-01-1b1p-01s.json.js';
import UK02_1B1P_01_F from './uk_02/UNT-01-1b1p-01h.json.js';
import UK02_1B2P_01 from './uk_02/UNT-01-1b2p-01s.json.js';
import UK02_1B2P_01_F from './uk_02/UNT-01-1b2p-01h.json.js';
import UK02_1B2P_02 from './uk_02/UNT-01-1b2p-02s.json.js';
import UK02_1B2P_02_F from './uk_02/UNT-01-1b2p-02h.json.js';
import UK02_1B2P_03 from './uk_02/UNT-01-1b2p-03s.json.js';
import UK02_1B2P_03_F from './uk_02/UNT-01-1b2p-03h.json.js';
import UK02_1B2P_04 from './uk_02/UNT-01-1b2p-04s.json.js';
import UK02_1B2P_04_F from './uk_02/UNT-01-1b2p-04h.json.js';
import UK02_2B3P_01 from './uk_02/UNT-01-2b3p-01s.json.js';
import UK02_2B3P_01_F from './uk_02/UNT-01-2b3p-01h.json.js';
import UK02_2B4P_01 from './uk_02/UNT-01-2b4p-01s.json.js';
import UK02_2B4P_01_F from './uk_02/UNT-01-2b4p-01h.json.js';
import UK02_2B4P_02 from './uk_02/UNT-01-2b4p-02s.json.js';
import UK02_2B4P_02_F from './uk_02/UNT-01-2b4p-02h.json.js';
import UK02_2B4P_03 from './uk_02/UNT-01-2b4p-03s.json.js';
import UK02_2B4P_03_F from './uk_02/UNT-01-2b4p-03h.json.js';
import UK02_3B5P_01 from './uk_02/UNT-01-3b5p-01s.json.js';
import UK02_3B5P_01_F from './uk_02/UNT-01-3b5p-01h.json.js';
import UK02_3B5P_02 from './uk_02/UNT-01-3b5p-02s.json.js';
import UK02_3B5P_02_F from './uk_02/UNT-01-3b5p-02h.json.js';
import UK02_3B6P_01 from './uk_02/UNT-01-3b6p-01s.json.js';
import UK02_3B6P_01_F from './uk_02/UNT-01-3b6p-01h.json.js';
import UK02_3B6P_02 from './uk_02/UNT-01-3b6p-02s.json.js';
import UK02_3B6P_02_F from './uk_02/UNT-01-3b6p-02h.json.js';
import { RgDataSetID } from './rg-data-set-id.js';

const ApartmentSets = {
    [RgDataSetID.uk_01]: [
        UK01_1B2P_V1,
        UK01_1B2P_V2,
        UK01_2B3P_V1,
        UK01_2B3P_V2,
        UK01_2B4P_V1,
        UK01_3B5P_V1,
        UK01_3B6P_V1
    ],
    [RgDataSetID.uk_02]: [
        UK02_1B1P_01,
        UK02_1B1P_01_F,
        UK02_1B2P_01,
        UK02_1B2P_01_F,
        UK02_1B2P_02,
        UK02_1B2P_02_F,
        UK02_1B2P_03,
        UK02_1B2P_03_F,
        UK02_1B2P_04,
        UK02_1B2P_04_F,
        UK02_2B3P_01,
        UK02_2B3P_01_F,
        UK02_2B4P_01,
        UK02_2B4P_01_F,
        UK02_2B4P_02,
        UK02_2B4P_02_F,
        UK02_2B4P_03,
        UK02_2B4P_03_F,
        UK02_3B5P_01,
        UK02_3B5P_01_F,
        UK02_3B5P_02,
        UK02_3B5P_02_F,
        UK02_3B6P_01,
        UK02_3B6P_01_F,
        UK02_3B6P_02,
        UK02_3B6P_02_F
    ]
};

export { ApartmentSets };
//# sourceMappingURL=apartment-sets.js.map
